import React, { useState } from "react";
import AddSellerDetails from "./AddSellerDetails.jsx";
import AddSellerProducts from "./AddSellerProducts";
import { useNavigate } from "react-router-dom";


export default function AddSeller() {
  const [activeTab, setActiveTab] = useState("details");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showSkipModal, setShowSkipModal] = useState(false);
  const [showSuccessSkipModal, setShowSuccessSkipModal] = useState(false);
  const Nav = useNavigate();

  return (
    <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-6 bg-white rounded-md border border-gray-200 shadow-[0_4px_8px_rgba(0,0,0,0.2)]">
      {/* Header & Buttons */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 gap-4">
       <div className="text-gray-500 font-semibold text-lg">
          Add Product Seller
        </div>
        {activeTab === "products" && (
          <div className="flex justify-center sm:justify-end space-x-3">
            <button
              className="px-4 py-1.5 border border-red-600 text-red-600 rounded hover:bg-red-50"
              onClick={() => setShowSkipModal(true)}
            >
              Skip for now
            </button>
            <button
              className="px-4 py-1.5 bg-red-600 text-white rounded hover:bg-red-700"
              onClick={() => setShowConfirmModal(true)}
            >
              Add Product Seller
            </button>
          </div>
        )}
      </div>
        <hr className="border-gray-300" />

      {/* Tabs */}
      <div className="flex justify-center sm:justify-start space-x-5 mb-4">
        <button
          onClick={() => setActiveTab("details")}
          className={`font-medium px-2 py-1 ${
            activeTab === "details"
              ? "text-red-600 border-b-4 rounded-sm border-red-600"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          Details
        </button>
        <button
          onClick={() => setActiveTab("products")}
          className={`font-medium px-2 py-1 ${
            activeTab === "products"
              ? "text-red-600 border-b-4 rounded-sm border-red-600"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          Products
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === "details" && <AddSellerDetails setActiveTab={setActiveTab}/>}
      {activeTab === "products" && (
        <div className="mt-6">
          <AddSellerProducts />
        </div>
      )}


      {/* Confirm Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center w-full max-w-sm">
            <div className="flex justify-center mb-4">
              <div className="bg-red-600 w-14 h-14 flex items-center justify-center rounded-full">
                <span className="text-white text-4xl">?</span>
              </div>
            </div>
            <p className="text-gray-800 font-medium mb-6 text-sm sm:text-base">
              Are you sure you want to add this buyer without assigning a Product?
            </p>
            <div className="flex justify-center space-x-4">
              <button
                className="border border-red-600 text-red-600 px-4 py-1.5 rounded hover:bg-red-50"
                onClick={() => setShowConfirmModal(false)}
              >
                Go Back
              </button>
              <button
                className="bg-red-600 text-white px-4 py-1.5 rounded hover:bg-red-700"
                onClick={() => {
                  console.log("Buyer added without product");
                  setShowConfirmModal(false);
                  setShowSuccessModal(true);
                }}
              >
                Yes, Add Now
              </button>
            </div>
          </div>
        </div>
      )}
      {showSkipModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center w-full max-w-sm">
            <div className="flex justify-center mb-4">
              <div className="bg-red-600 w-14 h-14 flex items-center justify-center rounded-full">
                <span className="text-white text-4xl">?</span>
              </div>
            </div>
            <p className="text-gray-800 font-medium mb-6 text-sm sm:text-base">
              Are you sure you want to add this buyer without assigning a Product Owner?
            </p>
            <div className="flex justify-center space-x-4">
              <button
                className="border border-red-600 text-red-600 px-4 py-1.5 rounded hover:bg-red-50"
                onClick={() => setShowSkipModal(false)}
              >
                Go Back
              </button>
              <button
                className="bg-red-600 text-white px-4 py-1.5 rounded hover:bg-red-700"
                onClick={() => {
                  console.log("Buyer added without product");
                  setShowSkipModal(false);
                  setShowSuccessSkipModal(true);
                }}
              >
                Yes, Add Now
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center w-full max-w-xs">
            <div className="flex justify-center mb-4">
              <div className="bg-red-600 w-14 h-14 flex items-center justify-center rounded-full">
                <span className="text-white text-4xl">✓</span>
              </div>
            </div>
            <p className="text-gray-800 font-medium mb-6 text-sm sm:text-base">
              "Buyer has been added successfully!"✅
            </p>
            <button
              className="bg-red-600 text-white px-6 py-1.5 rounded hover:bg-red-700"
              onClick={() => {
                setShowSuccessModal(false);
                Nav("/admin-dashboard/product-module");
              }}
            >
              Done
            </button>
          </div>
        </div>
      )}
      {showSuccessSkipModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center w-full max-w-xs">
            <div className="flex justify-center mb-4">
              <div className="bg-red-600 w-14 h-14 flex items-center justify-center rounded-full">
                <span className="text-white text-4xl">✓</span>
              </div>
            </div>
            <p className="text-gray-800 font-medium mb-6 text-sm sm:text-base">
              "Buyer has been added successfully!"✅
            </p>
            <button
              className="bg-red-600 text-white px-6 py-1.5 rounded hover:bg-red-700"
              onClick={() => {
                setShowSuccessSkipModal(false);
                Nav("/admin-dashboard/product-module");
              }}
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
}